module.exports = __webpack_public_path__ + "img/user.844ccf0b.png";